const products = [
  {
    id: 1,
    tag: "Security",
    name: "VPN Shield",
    tagline: "Unbreakable Privacy on iOS",
    description:
      "A high-performance Virtual Private Network application engineered for iOS. VPN Shield encrypts all device traffic with AES-256, masks your IP address, and routes connections through a global network of secure servers — all without sacrificing speed or battery life.",
    highlights: ["AES-256 Encryption", "Zero-Log Policy", "Global Server Network", "One-Tap Connect"],
    img: "https://public.readdy.ai/ai/img_res/d13a68f29119fd79fde4e116263715cc.jpg",
    accent: "bg-emerald-900",
    lightAccent: "bg-emerald-50",
    textAccent: "text-emerald-700",
  },
  {
    id: 2,
    tag: "Optimization",
    name: "Cleaner Pro",
    tagline: "Reclaim Your iPhone&apos;s Potential",
    description:
      "An intelligent storage management and system optimization tool for iOS. Cleaner Pro scans your device for duplicate files, junk caches, oversized media, and redundant contacts — then removes them safely to restore speed and free up precious storage space.",
    highlights: ["Smart Junk Scanner", "Duplicate Photo Finder", "Contact Merger", "Memory Booster"],
    img: "https://readdy.ai/api/search-image?query=iOS%20mobile%20cleaner%20optimization%20app%20interface%20on%20iPhone%2C%20light%20minimal%20UI%20showing%20storage%20charts%20and%20clean%20design%2C%20soft%20white%20background%20with%20green%20accents%2C%20professional%20product%20photography%20studio%20shot&width=420&height=580&seq=cleaner001&orientation=portrait",
    accent: "bg-teal-900",
    lightAccent: "bg-teal-50",
    textAccent: "text-teal-700",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-white py-24 md:py-32">
      <div className="w-full px-6 md:px-20">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gray-400 bg-gray-100 rounded-full px-4 py-1.5">
              Our Products
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-none tracking-tight mt-6">
              <span className="block">Built for</span>
              <span className="block mt-1">iOS.</span>
            </h2>
          </div>
          <p className="text-gray-400 font-light max-w-sm text-sm md:text-base leading-relaxed mb-1">
            Each product is designed from the ground up for the Apple ecosystem,
            meeting the strictest App Store guidelines and user expectations.
          </p>
        </div>

        {/* Product cards */}
        <div className="flex flex-col gap-8">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`rounded-3xl overflow-hidden flex flex-col ${
                index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
              } bg-[#F8F9FA]`}
            >
              {/* Image side */}
              <div className="lg:w-[380px] xl:w-[440px] shrink-0">
                <div className="h-[300px] lg:h-full overflow-hidden">
                  <img
                    src={product.img}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Text side */}
              <div className="flex-1 p-8 md:p-12 flex flex-col justify-center">
                <span
                  className={`inline-block text-xs font-semibold tracking-[0.3em] uppercase ${product.textAccent} ${product.lightAccent} rounded-full px-4 py-1.5 mb-5 self-start`}
                >
                  {product.tag}
                </span>
                <h3 className="text-3xl md:text-4xl font-black text-gray-900">{product.name}</h3>
                <p className="text-gray-500 font-light text-sm mt-1 tracking-wide">{product.tagline}</p>
                <p className="text-gray-500 text-sm md:text-base font-light leading-relaxed mt-6 max-w-lg">
                  {product.description}
                </p>

                <div className="mt-8 grid grid-cols-2 gap-3">
                  {product.highlights.map((h) => (
                    <div key={h} className="flex items-center gap-2">
                      <div className={`w-5 h-5 flex items-center justify-center rounded-full ${product.lightAccent} shrink-0`}>
                        <i className={`ri-check-line text-xs ${product.textAccent}`}></i>
                      </div>
                      <span className="text-gray-700 text-sm font-medium">{h}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-8 pt-8 border-t border-gray-200">
                  <p className="text-xs text-gray-400 tracking-widest uppercase">Available on</p>
                  <div className="flex items-center gap-2 mt-2">
                    <i className="ri-apple-fill text-gray-700 text-xl"></i>
                    <span className="text-gray-700 text-sm font-semibold">iOS App Store</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
